import sessionApi, { listResults } from './apiClient';
import type { FirearmCondition, FirearmRepair } from '../types/domain';

export interface CompleteRepairPayload {
  completionDate: string;
  postRepairCondition: FirearmCondition;
  workPerformed: string;
  photos: File[];
}

type RepairFilters = {
  admin_department?: number;
  status?: string;
};

export const repairService = {
  listRepairs: async (filters: RepairFilters = {}): Promise<FirearmRepair[]> => {
    const response = await sessionApi.get('/firearm-repairs/', { params: filters });
    return listResults<FirearmRepair>(response.data);
  },

  getRepair: async (id: number): Promise<FirearmRepair> => {
    const response = await sessionApi.get(`/firearm-repairs/${id}/`);
    return response.data;
  },

  completeRepair: async (
    id: number,
    payload: CompleteRepairPayload,
  ): Promise<FirearmRepair> => {
    const formData = new FormData();
    formData.append('completion_date', payload.completionDate);
    formData.append('post_repair_condition', payload.postRepairCondition);
    formData.append('work_performed', payload.workPerformed);
    payload.photos.forEach((photo) => formData.append('photos', photo));
    const response = await sessionApi.post(`/firearm-repairs/${id}/complete/`, formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },
};

export default repairService;
